import { HttpErrorResponse } from '@angular/common/http';

export namespace CommonApi {
  export enum MessageCode {
    invalidPassword = 'INVALID_PASS_VALUE',
    invalidUser = 'INVALID_USER_DETAIL',
    triesExceeded = 'INVALID_PIN_TRIES_EXCEEDED',
    accountLocked = 'ACCOUNT_LOCKED',
    userNotFound = 'RESOURCE_NOT_FOUND',
    declined = 'DECLINED',
    incorrectOneTimeCode = 'INCORRECT_ONE_TIME_CODE',
    exceededNoOfAttempt = 'EXCEEDED_NO_OF_ATTEMPT',
    invalidInput = 'INVALID_INPUT',
    wrongCurrentPassword = 'INVALID_PASS_VALUE',
    invalidNewPassword = 'INVALID_INPUT',
    newPasswordSameAsCurrent = 'PASSWORD_SAME_AS_CURRENT',
    resourceNotFound = 'RESOURCE_NOT_FOUND',
    quoteAlreadySettled = 'ALREADY_SETTLED',
    unauthorized = 'UNAUTHORIZED',
    tempPassword = 'TEMP_PASSWORD',
    invalidQCardNumber = 'INVALID_Q_CARD_NUMBER',
    invalidUid = 'INVALID_UID',
    finAmountBelowMin = 'FIN_AMOUNT_BELOW_MIN',
    finAmountAboveMax = 'FIN_AMOUNT_ABOVE_MAX',
    expired = 'EXPIRED',
    transactionFullyPaid = 'TRANSACTION_FULLY_PAID'
  }

  export enum MessageType {
    info = 'INFO',
    warning = 'WARNING',
    error = 'ERROR'
  }

  export interface ErrorResponseMessage {
    type: MessageType | string;
    code: MessageCode | string;
    description: string;
  }

  export interface ErrorResponse extends HttpErrorResponse {
    error: {
      messages: Array<ErrorResponseMessage>;
      title: string;
    };
  }
}

export function isErrorResponse(arg: any): arg is CommonApi.ErrorResponse {
  return arg.error !== undefined;
}
